/**
 * Перехват 401 в любом месте приложения (§11.3, §12.7).
 *
 * `web/src/lib/api.ts` — готовый клиент, менять его нельзя, поэтому ловим
 * ответ на уровне window.fetch: любой 401 от /api/, кроме самого входа,
 * означает «сессия закончилась» и переводит приложение на /login.
 * Сам ответ не трогаем — api.ts всё равно бросит ApiRequestError, просто
 * оболочка успевает увести пользователя на экран входа, а не на белый лист.
 */

type Handler = () => void

const LOGIN_PATH = '/api/auth/login'

let installed = false
let handlers: Handler[] = []

function pathOf(input: RequestInfo | URL): string {
  if (typeof input === 'string') return input
  if (input instanceof URL) return input.pathname
  return input.url
}

/**
 * Ставит перехватчик и возвращает функцию отписки.
 * Сам патч window.fetch снимается только с последним подписчиком.
 */
export function installUnauthorizedHandler(handler: Handler): () => void {
  handlers = [...handlers, handler]

  if (!installed) {
    installed = true
    const original = window.fetch.bind(window)
    window.fetch = async (input: RequestInfo | URL, init?: RequestInit) => {
      const res = await original(input, init)
      if (res.status === 401) {
        const path = pathOf(input)
        // 401 на самом входе — это «не подходит логин или пароль», а не истёкшая сессия.
        if (path.includes('/api/') && !path.includes(LOGIN_PATH)) {
          for (const h of handlers) h()
        }
      }
      return res
    }
  }

  return () => {
    handlers = handlers.filter((h) => h !== handler)
  }
}
